export default __webpack_public_path__ + "static/media/BG_header.8d193e19.png";